import { Component, inject, signal } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { RoutesConst } from '../shared/route-const';
import { AuthService } from './auth.service';
import { ForgotPassword } from './forgot-password/forgot-password';
import { Login } from './login/login';
import { ResetPasswordComponent } from './reset-password/reset-password.component';

@Component({
  selector: 'app-auth',
  imports: [MatCardModule, MatIconModule, Login, ForgotPassword, ResetPasswordComponent],
  templateUrl: './auth.html',
  styleUrl: './auth.scss',
})
export class Auth {
  private readonly router = inject(Router);
  currentUrl = signal(this.router.url);

  authSvc = inject(AuthService);

  ngOnInit() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.currentUrl.set(event.urlAfterRedirects);
    });

    console.log('Auth component initialized. Current URL:', this.currentUrl());
  }

  get isForgotPasswordUrl(): boolean {
    return this.currentUrl().includes(RoutesConst.forgotPassword);
  }
  get isResetPasswordUrl(): boolean {
    return this.currentUrl().includes(RoutesConst.resetPassword);
  }
  get isActiveAccountUrl(): boolean {
    return this.currentUrl().includes(RoutesConst.activateAccount);
  }
  get hasActiveUrlParam(): boolean {
    const url = new URL(this.currentUrl(), window.location.origin); // window.location.origin als Basis für relative URLs
    return url.searchParams.get('activateAccount') === '1';
  }

  get headerMessage(): string {
    if (this.isForgotPasswordUrl) {
      return 'Forgot your Password?';
    }
    if (this.isActiveAccountUrl) {
      return 'Activate your Account';
    }
    if (this.isResetPasswordUrl) {
      return this.hasActiveUrlParam ? 'Set your Password' : 'Reset Password';
    }
    return '';
  }
}
